/**
 * s54 (item 2 fase 1, decisao de Marcelo 13/10) - empresa em que o administrador da Gente esta TRABALHANDO.
 *
 * Fica no sessionStorage: vale so para esta aba e some ao fechar o navegador. `null` = a propria empresa.
 * A SEGURANCA nao mora aqui: a API recusa empresa alheia para quem nao tem escopo "*" (guarda A132) e grava
 * a auditoria no livro do cliente com o tenant de origem do ator (s54).
 */
export const WORK_TENANT_KEY = 'strongerh.workTenant'
export const WORK_TENANT_HEADER = 'X-Tenant-ID'
/** So quem lista empresas (platform_admin, seed RBAC) ve o seletor. */
export const WORK_TENANT_PERMISSION = 'tenant.list'

export function getWorkTenantId(): string | null {
  try {
    const v = window.sessionStorage.getItem(WORK_TENANT_KEY)
    return v && v.trim() ? v : null
  } catch {
    return null
  }
}

export function setWorkTenantId(id: string | null): void {
  try {
    if (id) window.sessionStorage.setItem(WORK_TENANT_KEY, id)
    else window.sessionStorage.removeItem(WORK_TENANT_KEY)
  } catch {
    // sem storage (aba privada restrita): a tela fica na propria empresa
  }
}
